module.exports = __webpack_public_path__ + "74631cc01bcaaa56481e15743a5abcfb.png";